// extracted by mini-css-extract-plugin
export default {"rating":"NP-z","numberOfStars":"OP-z","count":"PP-z","barGraphSpacing":"QP-z","barGraph":"RP-z"};